import * as React from 'react';
import { ICalendarState, IMonth, IDay } from '../../classes/calendar';

import { connect } from 'react-redux';
import moment from 'moment';
import { ICalendarAppState } from '../../redux-state';
import { IEvent } from '../../interfaces';
import { ICalendarAppText } from '../../redux-state/interfaces/text/calendar-app.text';
import GridDayView from './grid-day.view';

interface IGridDayExternalProps {
    day: IDay<IEvent>;
}

interface StateToProps {
    text: ICalendarAppText;
}

export type GridDayProps = IGridDayExternalProps & StateToProps;

export const GridDayBase: React.StatelessComponent<GridDayProps> = props => {
    return (
        <GridDayView {...props} />
    )
}

function mapStateToProps(state: ICalendarAppState): StateToProps {
    return {
        text: state.calendarText
    }
}

export default connect(mapStateToProps)(GridDayBase);